import React from 'react';

export const ArrowRightBtnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M8.46997 3.21963C8.76287 2.92681 9.23765 2.92676 9.53052 3.21963L14.7805 8.46963C14.893 8.58211 14.9615 8.72157 14.9875 8.86709C14.9953 8.91025 15.0002 8.95453 15.0002 8.99991C15.0002 9.04494 14.9952 9.08889 14.9875 9.13174C14.9616 9.27761 14.8932 9.41746 14.7805 9.53018L9.53052 14.7802C9.23765 15.073 8.76287 15.073 8.46997 14.7802C8.17708 14.4873 8.17708 14.0125 8.46997 13.7196L12.4397 9.74991H3.75024C3.33603 9.74991 3.00024 9.41412 3.00024 8.99991C3.00025 8.58569 3.33603 8.24991 3.75024 8.24991H12.4397L8.46997 4.28018C8.17708 3.98729 8.17708 3.51253 8.46997 3.21963Z"
      fill="#1D1D1E"
    />
  </svg>
);
